import Text from '../Base/Text/Text';

export default function GroupMemberAddPatientItem(props) {
	const { user, onClick, selected } = props;

	const handleClick = () => {
		onClick?.({
			id: user.id,
			label: user.profile.fullName,
		});
	};

	return (
		<div
			className={`autocomplete-custom-patient-search no-border ${
				selected ? 'active' : ''
			}`}
			onClick={handleClick}>
			<div className='autocomplete-tags__item__checkbox' />
			<div className='autocomplete-custom-patient-search__content'>
				<div className='autocomplete-custom-patient-search__content__title'>
					<Text tx={user.profile.fullName} />
				</div>
				<div className='autocomplete-custom-patient-search__content__subtitle'>
					r.č.: {user.profile.birthNumber} -{' '}
					<Text tx={user.profile.age + ' let'} inline />,
					{user.profile.address.fullAddress}
				</div>
				<div className='autocomplete-custom-patient-search__content__subtitle'>
					{user.doctors}
				</div>
			</div>
		</div>
	);
}

GroupMemberAddPatientItem.propTypes = {};
